import locale9ec66352 from '../../locales/en.json'
import localeae97e51a from '../../locales/pt-BR.json'
import locale8db5ed1c from '../../locales/es.json'
import locale38517862 from '../../locales/ar.json'
import locale73254525 from '../../locales/id.json'
import locale057ad21c from '../../locales/zh.json'
import locale275327d8 from '../../locales/fr.json'
import localeba2612ee from '../../locales/ja.json'
import locale2091eb08 from '../../locales/ko.json'
import locale0115aa4a from '../../locales/zh-TW.json'
import locale5e24acbc from '../../locales/tr.json'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en"},
  vueI18nLoader: false,
  locales: [{"code":"en","iso":"en","file":"en.json","dir":"ltr"},{"code":"pt-BR","iso":"pt-BR","file":"pt-BR.json","dir":"ltr"},{"code":"es","iso":"es","file":"es.json","dir":"ltr"},{"code":"ar","iso":"ar","file":"ar.json","dir":"rtl"},{"code":"id","iso":"id","file":"id.json","dir":"ltr"},{"code":"pt-BR","iso":"pt-BR","file":"pt-BR.json","dir":"ltr"},{"code":"zh","iso":"zh","file":"zh.json","dir":"ltr"},{"code":"fr","iso":"fr","file":"fr.json","dir":"ltr"},{"code":"ja","iso":"ja","file":"ja.json","dir":"ltr"},{"code":"ko","iso":"ko","file":"ko.json","dir":"ltr"},{"code":"zh-TW","iso":"zh-TW","file":"zh-TW.json","dir":"ltr"},{"code":"tr","iso":"tr","file":"tr.json","dir":"ltr"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/locales",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","iso":"en","file":"en.json","dir":"ltr"},{"code":"pt-BR","iso":"pt-BR","file":"pt-BR.json","dir":"ltr"},{"code":"es","iso":"es","file":"es.json","dir":"ltr"},{"code":"ar","iso":"ar","file":"ar.json","dir":"rtl"},{"code":"id","iso":"id","file":"id.json","dir":"ltr"},{"code":"pt-BR","iso":"pt-BR","file":"pt-BR.json","dir":"ltr"},{"code":"zh","iso":"zh","file":"zh.json","dir":"ltr"},{"code":"fr","iso":"fr","file":"fr.json","dir":"ltr"},{"code":"ja","iso":"ja","file":"ja.json","dir":"ltr"},{"code":"ko","iso":"ko","file":"ko.json","dir":"ltr"},{"code":"zh-TW","iso":"zh-TW","file":"zh-TW.json","dir":"ltr"},{"code":"tr","iso":"tr","file":"tr.json","dir":"ltr"}],
  localeCodes: ["en","pt-BR","es","ar","id","pt-BR","zh","fr","ja","ko","zh-TW","tr"],
}

export const localeMessages = {
  'en.json': () => Promise.resolve(locale9ec66352),
  'pt-BR.json': () => Promise.resolve(localeae97e51a),
  'es.json': () => Promise.resolve(locale8db5ed1c),
  'ar.json': () => Promise.resolve(locale38517862),
  'id.json': () => Promise.resolve(locale73254525),
  'zh.json': () => Promise.resolve(locale057ad21c),
  'fr.json': () => Promise.resolve(locale275327d8),
  'ja.json': () => Promise.resolve(localeba2612ee),
  'ko.json': () => Promise.resolve(locale2091eb08),
  'zh-TW.json': () => Promise.resolve(locale0115aa4a),
  'tr.json': () => Promise.resolve(locale5e24acbc),
}
